import themeFlix from '../../node_modules/@flixbus/honeycomb/dist/tokens/themes/flix/json/honeycomb-theme-flix.json.js';

// exporting a pre-made Theme object for setting the ThemeWrapper defaults.
var defaultThemes = {
  flix: themeFlix
};

export { defaultThemes as default, themeFlix };
